const OrganizationalSops = () =>
  import("@/components/platform/scisure_integration/OrganizationalSops.vue");

const routes = [
  {
    path: "/scisure/organizational-sops",
    alias: "/raft/scisure/sops/organizational",
    name: "organizational_sops",
    component: OrganizationalSops,
  },
];

export { routes as scisureRoutes };
